import React, { useEffect } from "react";
import { Redirect, useLocation } from "react-router-dom";
import { isOrgAccountActive } from "../../api/localstorage_api";
import { useAppContext } from "../../libs/contextLib";
import { isUserSignUpComplete, useUser } from "../../libs/hooksLib";
import PlaceholderPage from "../layout/PlaceholderPage";
import PitchRoute from "./PitchRoute";

export default function CandidateAuthenticatedRoute({ children, showLoginNav = true, title = null, ...rest }) {
  const { pathname, search } = useLocation();
  const { isAuthenticated } = useAppContext();
  const { setShowLoginNav } = useAppContext();
  const {user} = useUser();

  useEffect(() => {
    setShowLoginNav(showLoginNav);
  });

  return (
    <PitchRoute title={title} {...rest}>
      {isAuthenticated ? (
          !isOrgAccountActive() ? (
            isUserSignUpComplete(isAuthenticated, user) ? (
              children
            ) : (
              <Redirect to={
                `/signup?redirect=${pathname}${search}`
              } />
            )
          ) : (
              <PlaceholderPage>
                <h3>Sorry! This is a candidate only page, please log out of your organisation account to view.</h3>
              </PlaceholderPage>
          )
      ) : (
        <Redirect to={
          `/signup?redirect=${pathname}${search}`
        } />
      )}
    </PitchRoute>
  );
}